import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Register.scss";
import { checkValidData } from "../utils/validate";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    profileImage: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      [name]: name === "profileImage" ? files[0] : value,
    });
  };
  const [errorMessage, setErrorMessage] = useState(null);

  const [passwordMatch, setPasswordMatch] = useState(true);

  useEffect(() => {
    setPasswordMatch(
      formData.password === formData.confirmPassword ||
        formData.confirmPassword === ""
    );
    
  });

  const navigate = useNavigate();
  const backend_url = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    

    const message = checkValidData(formData.password);
    setErrorMessage(message);
    if (message) {
      return;
    }

    try {
      const register_form = new FormData();

      for (var key in formData) {
        register_form.append(key, formData[key]);
      }

      const response = await fetch(`${backend_url}/auth/register`, {
        method: "POST",
        body: register_form,
      });

      /* Get data after fetching */
      const loggedIn = await response.json()

      if (response.ok) {
        navigate("/login");
      }

      // If response is wrong or response status is not in the range 200-299
      if (!response.ok) {
        setErrorMessage(loggedIn.message);
        return;
      }
      // console.log(response.status);
    } catch (err) {
      console.log("error",err)
      console.log("Registration failed", err.message);
    }
  };

  return (
      <>
      <Navbar searchBar={false} />
    <div className="register">
      <div className="register_content">
        <form className="register_content_form" onSubmit={handleSubmit}>
          <input
            placeholder="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            placeholder="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
          <input
            placeholder="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            />
          <input
            placeholder="Password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            type="password"
            required
          />
          <input
            placeholder="Confirm Password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            type="password"
            required
          />

          {!passwordMatch && (
            <p style={{ color: "red" }}>Passwords are not matched!</p>
          )}

          <input
            id="image"
            type="file"
            name="profileImage"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleChange}
            required
          />
          <label htmlFor="image">
            <img src="/assets/addImage.png" alt="add-profile-pic" />
            <p>Upload Your Photo</p>
          </label>

          {formData.profileImage && (
            <img
              src={URL.createObjectURL(formData.profileImage)}
              alt="profile-pic"
              style={{ maxWidth: "80px" }}
            />
          )}

          {errorMessage && (
                <div>
                    <p style={{ color: "red", whiteSpace: 'pre-line'}}>{errorMessage}</p>
                </div>
            )}


          <button type="submit" disabled={!passwordMatch}>
            REGISTER
          </button>
        </form>
        <a href="/login">Already have an account? Log In Here</a>
      </div>
    </div>
    <Footer/>
            </>
  );
};

export default RegisterPage;
